import { Observable } from 'rxjs/Rx';
import { Component, OnInit, Inject } from '@angular/core';
import { DataStateChangeEvent, GridDataResult } from "@progress/kendo-angular-grid";
import { State, process } from "@progress/kendo-data-query";
import { CardService } from '../services/card.service';

import { Mastermind } from '../models/mastermind';
import { CustomMastermindEditComponent } from './custom-mastermind-edit.component';

@Component({
    selector: 'custom-mastermind',
    template: require('./custom-mastermind.component.html'),
    styles: [require('../styles/legendary.css')]
})
export class CustomMastermindComponent implements OnInit {
    state: State = { skip: 0, take: 10 };
    mastermindsResult: GridDataResult;
    editMastermind: Mastermind;
    isNew: boolean = false;

    constructor(private service: CardService) { }


    ngOnInit() {
        this.refreshGrid();
    }

    public refreshGrid(): void {
        this.service.fetchMasterminds(this.state)
            .subscribe(data => {
                this.mastermindsResult = data;
            });
    }

    public onStateChange(state: State) {
        this.state = state;

        this.refreshGrid();
    }

    public addHandler() {
        this.editMastermind = new Mastermind();
        this.isNew = true;
    }

    public editHandler({ dataItem }) {
        this.editMastermind = dataItem;
        this.isNew = false;
    }

    public cancelHandler() {
        this.editMastermind = undefined;
    }

    public saveHandler(mastermind: Mastermind) {
        this.service.saveMastermind(mastermind, this.isNew).subscribe(result => {
            this.refreshGrid();
            this.editMastermind = undefined;
        });
    }

    public removeHandler({ dataItem }) {
        this.service.removeMastermind(dataItem.LegendaryMasterMindId)
            .subscribe(result => {
                this.refreshGrid();
            });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Apps/legendary/custom/custom-mastermind.component.ts